import {
    Activity,
    BriefcaseBusiness,
    Cable,
    FileStack,
    FolderOpen,
    House,
    type LucideIcon,
    Settings,
    Users,
} from 'lucide-react';

import type { Translations } from '@/core/i18n/locales/de.ts';
import RecapIcon from '@/recaps/components/RecapIcon.tsx';

export type NavKey = keyof Translations['nav'];

export interface NavItem {
    navKey: NavKey;
    path: string;
    icon: LucideIcon;
    isInMobileBar: boolean;
    // Active only on its path itself, not on the pages below it.
    isEnd?: boolean;
    // Pages of the section outside its path, e.g. a recap's page for the recaps.
    subPaths?: string[];
}

export const PERSONAL_NAV_ITEMS: NavItem[] = [
    { navKey: 'home', path: '/', icon: House, isInMobileBar: true, isEnd: true },
    { navKey: 'activities', path: '/activities', icon: Activity, isInMobileBar: true },
];

// Shown under the rail's "Workspace" heading.
export const WORKSPACE_NAV_ITEMS: NavItem[] = [
    { navKey: 'projects', path: '/projects', icon: FolderOpen, isInMobileBar: true, subPaths: ['/projects/*'] },
    // Not in the mobile bar, which has room for six; the projects' group headings lead to the clients.
    { navKey: 'clients', path: '/clients', icon: BriefcaseBusiness, isInMobileBar: false, subPaths: ['/clients/*'] },
    { navKey: 'recaps', path: '/recaps', icon: RecapIcon, isInMobileBar: true, subPaths: ['/recaps/*'] },
    { navKey: 'sources', path: '/sources', icon: FileStack, isInMobileBar: true, subPaths: ['/sources/*'] },
];

// Last under the rail's "Workspace" heading, apart from the sections by a line. The settings' tabs that are looked
// for most get a link of their own, so the settings themselves are active only on their general tab.
export const SETTINGS_NAV_ITEMS: NavItem[] = [
    {
        navKey: 'connections',
        path: '/settings/connections',
        icon: Cable,
        isInMobileBar: false,
        subPaths: ['/settings/connections/*'],
    },
    { navKey: 'team', path: '/settings/team', icon: Users, isInMobileBar: false },
    { navKey: 'settings', path: '/settings', icon: Settings, isInMobileBar: true, isEnd: true },
];

export const NAV_ITEMS: NavItem[] = [...PERSONAL_NAV_ITEMS, ...WORKSPACE_NAV_ITEMS, ...SETTINGS_NAV_ITEMS];

// A client's employee has only their home and their client's recaps (plan/DECISIONS.md D61).
export const EMPLOYEE_NAV_ITEMS: NavItem[] = NAV_ITEMS.filter(
    (item) => item.navKey === 'home' || item.navKey === 'recaps'
);
